import { render } from "./collectors-club-settings.vue?vue&type=template&id=2b5a3bd9"
import script from "./collectors-club-settings.vue?vue&type=script&lang=js"
export * from "./collectors-club-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__